import { useVariant } from "../../hooks/useVariant/useVariant";
import { ensureIsActiveVariant } from "../../utils/product/ensureIsActive";
import { isInStoreOnly } from "../../utils/variant/isInStoreOnly";
import { StandardProps } from "../componentMap";
import { InStoreOnlyMessageBoxUI } from "./InStoreOnlyMessageBoxUI";

export function InStoreOnlyMessageBox({
  product,
}: Pick<StandardProps, "product">) {
  const { variant } = useVariant(product);
  const activeVariant = ensureIsActiveVariant(variant);
  const isVariantInStoreOnly = !!activeVariant && isInStoreOnly(activeVariant);

  return <InStoreOnlyMessageBoxUI isInStoreOnly={isVariantInStoreOnly} />;
}
